'use client'

import * as Sentry from '@sentry/nextjs'

import type { ErrorProps } from '@ui/shared/pages'
import { Error as ErrorComponent } from '@ui/shared/pages'

export function Error({ error, reset, className, locale, auth }: Omit<ErrorProps, 'onErrorCapture'>) {
  return (
    <ErrorComponent
      error={error}
      onErrorCapture={() => Sentry.captureException(error)}
      reset={reset}
      className={className}
      locale={locale}
      auth={auth}
    />
  )
}
